import React, { Component } from 'react'

export default class NotAuthorized extends Component {
  render() {
    return (
      <h1>NotAuthorized</h1>
    )
  }
}
